'use strict';

document.addEventListener("DOMContentLoaded", () => {
    var form = document.querySelector('.mktoForm[data-formInstance="mkto-form-instance"]');
    if(form.dataset.formid == 2867) {
        (function() {
            /* config area - replace with your instance values */
            var formIds = [2867],
                podId = '//app-sj05.marketo.com',
                munchkinId = '811-SJQ-803';

            /* no need to touch anything below this line */

            var MKTOFORM_ID_PREFIX = 'mktoForm_', MKTOFORM_ID_ATTRNAME = 'data-formId';

            formIds.forEach(function(formId) {
                var loadForm = MktoForms2.loadForm.bind(
                    MktoForms2,
                    podId,
                    munchkinId,
                    formId
                    ),
                    formEls = [].slice.call(
                        document.querySelectorAll('[' + MKTOFORM_ID_ATTRNAME + '="' + formId + '"]')
                    );

                (function loadFormCb(formEls) {
                    var formEl = formEls.shift();
                    formEl.id = MKTOFORM_ID_PREFIX + formId;

                    loadForm(function(form) {
                        formEl.id = '';
                        formEls.length && loadFormCb(formEls);
                    });
                })(formEls);
            });
        })();
    }
});
